import React from 'react';
// Constants
import {
  CompantTagLine,
  CompanyAddress,
  CompanyPhoneNumber,
  ContactEmailAddress,
  WebDeveloperBusinessName,
  WebDeveloperWebsiteAddress,
  WebDeveloperWebsiteUrl,
} from '../../utils/Constants';
// Components
import FooterSocialCTA from './FooterSocialCTA';
// Images
import {
  foodServiceHoursArray,
  openHoursArray,
} from '../../utils/data/CompanyData';
// Images
import LogoWhite from '../../assets/images/logos/the-tavistock-inn-hotel-and-resturant.webp';

function FooterComponent() {
  return (
    <footer className='grid bg-alt-background border-t-2 border-solid border-colour2 w-full overflow-hidden py-6 md:py-12 px-6 md:px-20 font-poppins'>
      <div className='grid lg:grid-cols-a1a mx-auto gap-6 bg-white px-2 md:px-10 py-8 w-full'>
        {/* Logo section */}
        <section className='grid h-fit my-auto gap-4 py-2 w-full'>
          <div className='grid items-center justify-center'>
            {/* Company Logo */}
            <div>
              <img
                src={LogoWhite}
                alt='The Tavistock Inn Hotel'
                className='w-12 lg:w-20'
                loading='lazy'
              />
            </div>
          </div>
          <div className='text-center'>
            <p className='text-sm'>{CompantTagLine}</p>
          </div>
          <FooterSocialCTA />
        </section>

        {/* Footer links */}
        <section className='grid lg:grid-cols-2 px-2 gap-2 w-full'>
          <div className='grid grid-rows-reg w-full lg:justify-center text-center'>
            <div className='grid grid-rows-reg justify-center text-center'>
              {/* Food Service Hours Header */}
              <div className='text-left'>
                <h6>Food Service Hours</h6>
                <div className='border-b-2 border-solid border-colour5 pt-2 mb-2'></div>
              </div>

              {/* Food Service Hours List */}
              <ul className='text-left'>
                {foodServiceHoursArray.map((hours) => {
                  return (
                    <li
                      key={hours.day}
                      className='font-medium text-sm flex justify-between'
                    >
                      <span>{hours.day}</span>
                      <span>{hours.hours}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <div className='grid grid-rows-reg justify-center text-center'>
            {/* Opening Times Header */}
            <div className='text-left'>
              <h6>Opening Times</h6>
              <div className='border-b-2 border-solid border-colour5 pt-2 mb-2'></div>
            </div>

            {/* Opening Times List */}
            <ul className='text-left'>
              {openHoursArray.map((hours) => {
                return (
                  <li
                    key={hours.day}
                    className='font-medium text-sm flex justify-between'
                  >
                    <span>{hours.day}</span>
                    <span>{hours.hours}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </section>

        {/* Social media links */}
        <section className='grid grid-rows-reg gap-2 w-fit px-2'>
          <div className='text-left'>
            <h6>Contact</h6>
            <div className='border-b-2 border-solid border-colour5 pt-2 mb-2'></div>
          </div>

          <div className='grid gap-1 h-fit'>
            <div>
              <a href={`mailto:${ContactEmailAddress}`}>
                <p>
                  <span className='font-semibold'>Email: </span>
                  {ContactEmailAddress}
                </p>
              </a>
            </div>
            <div>
              <a href={`tel:${CompanyPhoneNumber}`}>
                <p>
                  <span className='font-semibold'>Phone: </span>+
                  {CompanyPhoneNumber} (UK)
                </p>
              </a>
            </div>
            <div>
              <p>
                <span className='font-semibold'>Location: </span>{' '}
                {CompanyAddress}
              </p>
            </div>
          </div>

          <div className='grid py-2'>
            <div>
              <p>Proudly Made by {WebDeveloperBusinessName}</p>
              <p>
                <a
                  href={WebDeveloperWebsiteUrl}
                  rel='noreferrer'
                  target='_blank'
                >
                  {WebDeveloperWebsiteAddress}
                </a>
              </p>
            </div>
            {/* Your credit link */}

            <a
              href='https://bytetoast-studio.com'
              target='_blank'
              rel='noopener noreferrer nofollow'
              className='underline hover:opacity-100 transition'
            >
              ByteToast Studio
            </a>
          </div>
        </section>
      </div>
    </footer>
  );
}

export default FooterComponent;
